import { render } from "./TandCsModal.vue?vue&type=template&id=970ff0f4&scoped=true&lang=pug"
import script from "./TandCsModal.vue?vue&type=script&lang=ts"
export * from "./TandCsModal.vue?vue&type=script&lang=ts"

import "./TandCsModal.vue?vue&type=style&index=0&id=970ff0f4&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-970ff0f4"

export default script